export default "__VITE_ASSET__Ds9s0Zr5__"